import { Period, Sido } from "./types";

export const LEFT_SIDE_BAR_WIDTH = "15rem";
export const SIDO: Sido[] = [
  "전국",
  "서울특별시",
  "경기도",
  "인천광역시",
  "대전광역시",
  "광주광역시",
  "세종특별자치시",
  "부산광역시",
  "대구광역시",
  "울산광역시",
];
export const PERIOD_LIST: Period[] = ["1주", "1달", "3달", "전체"];
